import type { Bootstrap } from "../../shared/api/generated/contracts";

export type Section = Bootstrap["abilities"][number];

/** System sections come from a provider; the owner's own have none. */
export function isSystemSection(section: Section): boolean {
  return Boolean(section.provider_key);
}

/**
 * Home is the section this device opened last. With several to choose from
 * and none chosen yet there is no home: the first-run screen asks instead.
 */
export function homeSectionFor(
  sections: Section[],
  lastId: string | undefined,
): Section | undefined {
  return (
    sections.find((item) => item.id === lastId) ??
    (sections.length === 1 ? sections[0] : undefined)
  );
}
